module.exports = __webpack_public_path__ + "img/img_covertack_ribbon.e97f5d08.png";